import {
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CarOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DollarOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  FlagOutlined,
  MessageOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  ShoppingOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import { userHasPermission } from '../utils/permissions';

const GROUP_ORDER = ['main', 'orgMgmt', 'commerce', 'finance', 'users', 'operations', 'system'];

const ICON_MAP = {
  DashboardOutlined,
  BankOutlined,
  TeamOutlined,
  UserOutlined,
  AuditOutlined,
  SettingOutlined,
  FlagOutlined,
  FileTextOutlined,
  DollarOutlined,
  WarningOutlined,
  CarOutlined,
  FileDoneOutlined,
  MessageOutlined,
  CustomerServiceOutlined,
  QuestionCircleOutlined,
  BarChartOutlined,
  NotificationOutlined,
  ShoppingOutlined,
  CalendarOutlined,
};

/**
 * @param {import('../../app/routeConfig').AppRoute[]} routes
 */
export function useNavItems(routes) {
  const { user } = useAuth();
  const { t } = useTranslation();

  return useMemo(() => {
    const groups = {};
    routes
      .filter((route) => route.nav)
      .filter((route) => !route.permission || userHasPermission(user, route.permission))
      .forEach((route) => {
        const group = route.nav.group || 'main';
        if (!groups[group]) groups[group] = [];
        const Icon = ICON_MAP[route.nav.icon] || DashboardOutlined;
        groups[group].push({
          key: route.path,
          icon: <Icon />,
          label: route.nav.badge
            ? `${t(route.nav.labelKey)} (${t('nav.comingSoon')})`
            : t(route.nav.labelKey),
          disabled: route.nav.disabled,
        });
      });
    const ordered = {};
    GROUP_ORDER.forEach((group) => {
      if (groups[group]?.length) ordered[group] = groups[group];
    });
    Object.keys(groups).forEach((group) => {
      if (!ordered[group]) ordered[group] = groups[group];
    });
    return ordered;
  }, [routes, user, t]);
}
